/**
 * @todo This is a placeholder for a PageError fallback render that would make use of the error
 * component context to show correlationId and sessionId and a nice error message
 * @returns a PageError fallback render
 */
export var PageError = function () {
    return null;
};
//# sourceMappingURL=PageError.js.map